import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byId: {},
    activeUserWelcomeAsset: {}
});

export default (state = getInitialState(), action) => {
    switch (action.type) {
        case ACTIONS.GET_ACTIVE_USER_WELCOME_ASSET: {
            const { activeUserWelcomeAsset } = action.payload;
            return {
                byId: { ...state.byId },
                activeUserWelcomeAsset
            };
        }

        default:
            return state;
    }
};
